// extracted by mini-css-extract-plugin
export default {"header":"Header_header__H5QIS","logo":"Header_logo__9F13w","nav":"Header_nav__L6mbQ"};